import script from "./AnnualReportsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualReportsView.vue?vue&type=script&setup=true&lang=js"

import "./AnnualReportsView.vue?vue&type=style&index=0&id=2111f087&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2111f087"]])

export default __exports__